export default {
	state: {
		current: null,
		forecast: null,
		alerts: null,
		day: null,
		map_img: null

	},
	mutations: {

	}
}
